// Shared Framer Motion variants and easing tokens.
export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE },
  },
};

export const stagger = (staggerChildren = 0.12, delayChildren = 0) => ({
  hidden: {},
  visible: {
    transition: { staggerChildren, delayChildren },
  },
});

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: EASE } },
};

// Line-by-line masked reveal (used with an overflow-hidden wrapper)
export const lineParent = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.14, delayChildren: 0.15 } },
};
export const lineChild = {
  hidden: { y: "110%" },
  visible: { y: "0%", transition: { duration: 1.05, ease: EASE } },
};

export const viewport = { once: true, margin: "-80px" };
